import iconBack from '../../../assets/images/icon_back.svg'
import { useBuildingContext } from '../../../contexts/buildingContext'
import { PannellumViewersProvider } from '../../../contexts/pannellumContext'
import { RealtimePositionProvider } from '../../../contexts/realtimeContext'
import { useNavigation } from '../../../hooks/useNavigation'

import { SplitScreenManager } from './components/SplitScreenManager'
import { TimeScroll } from './components/TimeScroll'
// import { DebugPanel } from './components/DebugPannel';
import { ImageViewerProvider } from './imageViewerContext'
import { FullscreenPanoramaBackButton, FullscreenPanoramaBase } from './styles'

export const ImageViewer = ({
  minDate,
  maxDate,
}: { minDate?: Date; maxDate?: Date } = {}) => {
  const { navigateToCurrentPoint } = useNavigation()
  const { state: buildingState } = useBuildingContext()

  return (
    <FullscreenPanoramaBase
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      {/*<DebugPanel />*/}
      <RealtimePositionProvider>
        <PannellumViewersProvider>
          <ImageViewerProvider>
            <SplitScreenManager minDate={minDate} maxDate={maxDate} />
            <FullscreenPanoramaBackButton
              onClick={() => navigateToCurrentPoint()}
            >
              <img src={iconBack} alt="Back" />
              <span>Back</span>
            </FullscreenPanoramaBackButton>
            <TimeScroll point={buildingState.pointData} />
          </ImageViewerProvider>
        </PannellumViewersProvider>
      </RealtimePositionProvider>
    </FullscreenPanoramaBase>
  )
}
